import React from "react";

import { MenuCategoryDto } from "services/menu/restModels";

import { localizedText } from "shared/lib/localizedMap";
import { itemsCountLabel } from "shared/lib/menuLabels";
import {
    Button,
    DataTable,
    DataTableColumn,
    EmptyState,
    Pagination,
    SearchInput,
} from "shared/ui";

import { useStopListContext } from "features/StopList/context";
import {
    Dot,
    Filters,
    FullLabel,
    RowAction,
    SearchField,
    ShortLabel,
} from "features/StopList/styles";

export const CategoriesTab = () => {
    const state = useStopListContext();

    const columns: DataTableColumn<MenuCategoryDto>[] = [
        { key: "dot", role: "indicator", render: () => <Dot $tone="amber" /> },
        {
            key: "name",
            title: "Категория",
            role: "primary",
            render: (category) => localizedText(category.name, state.locale),
        },
        {
            key: "items",
            title: "Скрыто позиций",
            role: "secondary",
            width: 180,
            render: (category) => itemsCountLabel(category.itemsCount),
        },
        {
            key: "action",
            role: "action",
            width: 176,
            render: (category) => (
                <RowAction>
                    <Button
                        variant="outlined"
                        color="neutral"
                        size="compact"
                        disabled={state.pendingCategoryIds.has(category.id)}
                        onClick={() => state.returnCategoryToSale(category)}
                    >
                        <FullLabel>Вернуть в продажу</FullLabel>
                        <ShortLabel>Вернуть</ShortLabel>
                    </Button>
                </RowAction>
            ),
        },
    ];

    const renderBody = () => {
        if (state.stopCategories.length === 0) {
            return state.categoriesQuery.trim() !== "" ? (
                <EmptyState
                    title="Ничего не найдено"
                    description="Попробуйте изменить запрос."
                    action={
                        <Button variant="text" onClick={() => state.setCategoriesQuery("")}>
                            Сбросить фильтры
                        </Button>
                    }
                />
            ) : (
                <EmptyState
                    title="Ни одна категория не скрыта целиком"
                    description="Скрытая категория убирает из меню все свои позиции разом."
                />
            );
        }

        return (
            <DataTable
                columns={columns}
                rows={state.pagedStopCategories}
                rowKey={(category) => category.id}
                footer={
                    <Pagination
                        page={state.categoriesPage}
                        pageSize={state.pageSize}
                        total={state.stopCategories.length}
                        onChange={state.setCategoriesPage}
                    />
                }
            />
        );
    };

    return (
        <>
            <Filters>
                <SearchField>
                    <SearchInput
                        value={state.categoriesQuery}
                        placeholder="Поиск по категориям"
                        onChange={state.setCategoriesQuery}
                    />
                </SearchField>
            </Filters>

            {renderBody()}
        </>
    );
};
